<template>
    <div class="content">
        <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
            <time-attendance>
            </time-attendance> 
            </div>
        </div>  
        </div>
    </div>
    </template>
    <script>
    /* eslint-disable */
    import timeAttendance from './todo-time-attendance'
    export default {
        components: {
            timeAttendance
        }
    }
    </script>
    <style lang="scss">
        .modal.show .modal-dialog {
            -webkit-transform: translate(0, 5%);
            -o-transform: translate(0, 5%);
            transform: translate(0, 5%);
        }
        .bg-breadcrum{
            background:#fff;
        }
        .bg-tertiary{
            background-color: #ff7600 !important;
        }
        .img-custom{
            border-radius:100px; 
        }
        table input[type=time],
        table input[type=number],
        table input[type=text] {
            border: 1px solid gray;
            border-radius: 3px;
        }
    </style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-time-attendance/base-time-attendance.vue